(function(){
    //Login/Signup modal window - by CodyHouse.co
    function FormSignin( element ) {
        this.elementForm = element;
        this.blocksForm = this.elementForm.getElementsByClassName('js-signin-form-block');
        this.switchersForm = this.elementForm.getElementsByClassName('js-signin-form-switcher')[0].getElementsByTagName('a');
        this.triggersForm = document.getElementsByClassName('js-signin-form-trigger');
        this.init();
        this.checkUrlHash();
    };

    FormSignin.prototype.init = function() {
        var selfForm = this;
        //open modal/switch form
        for(var i =0; i < this.triggersForm.length; i++) {
            (function(i){
                selfForm.triggersForm[i].addEventListener('click', function(event){
                    if( event.target.hasAttribute('data-signin') ) {
                        event.preventDefault();
                        selfForm.showSigninFormForm(event.target.getAttribute('data-signin'));
                    }
                });
            })(i);
        }

        // Listener for hash change
        window.addEventListener('hashchange', function() {
            selfForm.checkUrlHash();
        });
    };

    FormSignin.prototype.showSigninFormForm = function(type) {
        // show modal if not visible
        !hasClassForm(this.elementForm, 'cd-signin-form--is-visible') && addClassForm(this.elementForm, 'cd-signin-form--is-visible');
        // show selected form
        for( var i=0; i < this.blocksForm.length; i++ ) {
            this.blocksForm[i].getAttribute('data-type') == type ? addClassForm(this.blocksForm[i], 'cd-signin-form__block--is-selected') : removeClassForm(this.blocksForm[i], 'cd-signin-form__block--is-selected');
        }
        //update switcher appearance
        var switcherType = (type == 'signupForm') ? 'signupForm' : 'loginForm';
        for( var i=0; i < this.switchersForm.length; i++ ) {
            this.switchersForm[i].getAttribute('data-type') == switcherType ? addClassForm(this.switchersForm[i], 'cd-selected-form') : removeClassForm(this.switchersForm[i], 'cd-selected-form');
        }
    };

    // function to check the URL hash and show the appropriate form
    FormSignin.prototype.checkUrlHash = function() {
        var hash = window.location.hash.replace('#', '');
        if(hash == 'signupForm' || hash == 'loginForm') {
            this.showSigninFormForm(hash);
        }
    };

    var signinForm = document.getElementsByClassName("js-signin-form")[0];
    if( signinForm ) {
        new FormSignin(signinForm);
    }

    //class manipulations - needed if classList is not supported
    function hasClassForm(el, className) {
        if (el.classList) return el.classList.contains(className);
        else return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
    }
    function addClassForm(el, className) {
        var classList = className.split(' ');
        if (el.classList) el.classList.add(classList[0]);
        else if (!hasClassForm(el, classList[0])) el.className += " " + classList[0];
        if (classList.length > 1) addClassForm(el, classList.slice(1).join(' '));
    }
    function removeClassForm(el, className) {
        var classList = className.split(' ');
        if (el.classList) el.classList.remove(classList[0]);
        else if(hasClassForm(el, classList[0])) {
            var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
            el.className=el.className.replace(reg, ' ');
        }
        if (classList.length > 1) removeClassForm(el, classList.slice(1).join(' '));
    }
    function toggleClassForm(el, className, bool) {
        if(bool) addClassForm(el, className);
        else removeClassForm(el, className);
    }



})();